import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import '@/styles/index.css'
import Amplify from '@aws-amplify/core'
import CrispChat from '@dansmaculotte/vue-crisp-chat'
import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'
import VueObserveVisibility from 'vue-observe-visibility'
import VueWorker from 'vue-worker'
import { VueMaskDirective } from 'v-mask'
import JsonViewer from 'vue-json-viewer'
import * as Sentry from '@sentry/vue'
import CountryFlag from 'vue-country-flag'
import VueKonva from 'vue-konva'
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import { SimpleSVG } from 'vue-simple-svg'
import PortalVue from 'portal-vue'
Vue.use(PortalVue)

Vue.component('simple-svg', SimpleSVG)

Vue.component('vue-phone-number-input', VuePhoneNumberInput)

if (window.location.hostname.match(/dashboard.pandavideo.com/)) {
  Sentry.init({
    Vue,
    dsn: 'https://9114ea67065547d7bde20a4c7899269d@o1279024.ingest.sentry.io/6479390',
    release: 'dashboard@' + process.env.VUE_APP_DASHBOARD_BUILD_VERSION,
    tracesSampleRate: 0,
  })
}

try {
  const [locale] = JSON.parse(localStorage.getItem('locale')).split('_')

  window.CRISP_RUNTIME_CONFIG = {
    locale: locale === 'en' ? 'eng' : locale,
  }
} catch (e) {
  window.CRISP_RUNTIME_CONFIG = {
    locale: 'pt-BR',
  }
}
Vue.use(CrispChat, {
  websiteId: process.env.VUE_APP_CRISP,
})

Vue.use(VueWorker)
Vue.use(VueKonva)
Vue.config.productionTip = false
Vue.use(VuePlyr)
Vue.use(JsonViewer)
Vue.use(VueObserveVisibility)
Vue.component(CountryFlag)
Vue.directive('mask', VueMaskDirective)

Amplify.configure({
  Auth: {
    region: process.env.VUE_APP_COGNITO_REGION,
    userPoolId: process.env.VUE_APP_COGNITO_POOL,
    userPoolWebClientId: process.env.VUE_APP_COGNITO_CLIENT,
  },
})
Vue.config.productionTip = false
new Vue({
  store,
  router,
  vuetify,
  render: (h) => h(App),
}).$mount('#app')
